// Updated ActionButtons.jsx with removed functionality and fixed props
import React from 'react';

const ActionButtons = ({
  isLoading,
  fundEthBalance,
  fundTokenBalance,
  walletTokenBalance,
  mode,
  tokenType,
  onDeposit,
  onWithdraw,
  onMint,
  onWithdrawTokens,
  onRedeemFund,
  onDepositTokens, // Added this prop back in
  inputAmount,
}) => {
  // Check if any input is available (non-zero)
  const hasInput = inputAmount && parseFloat(inputAmount) > 0;
  
  // Check availability of various balances (non-zero)
  const hasFundEth = parseFloat(fundEthBalance) > 0;
  const hasFundTokens = parseFloat(fundTokenBalance) > 0;
  const hasWalletTokens = parseFloat(walletTokenBalance) > 0;

  // Debug log to check values
  console.log('ActionButtons - Rendering with:', {
    mode,
    tokenType,
    fundEthBalance,
    fundTokenBalance,
    walletTokenBalance,
    hasInput,
    hasFundEth,
    hasFundTokens,
    hasWalletTokens
  });

  return (
    <div className="mb-4">
      {mode === 'deposit' ? (
        // Deposit/Withdraw Mode
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {tokenType === 'ETH' ? (
            // ETH actions
            <>
              <button
                type="button"
                onClick={onDeposit}
                disabled={isLoading || !hasInput}
                className={`py-2 px-4 rounded-lg font-medium text-white 
                  ${isLoading || !hasInput
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-blue-500 hover:bg-blue-600 focus:ring-blue-500'
                  } focus:outline-none focus:ring-2 focus:ring-opacity-50 transition`}
              >
                Deposit ETH to Fund
              </button>
              <button
                type="button"
                onClick={onWithdraw}
                disabled={isLoading || !hasFundEth}
                className={`py-2 px-4 rounded-lg font-medium text-white 
                  ${isLoading || !hasFundEth
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-blue-500 hover:bg-blue-600 focus:ring-blue-500'
                  } focus:outline-none focus:ring-2 focus:ring-opacity-50 transition`}
              >
                {hasInput 
                  ? `Withdraw ${inputAmount} ETH from Fund` 
                  : `Withdraw ETH from Fund (${parseFloat(fundEthBalance).toFixed(4)} available)`}
              </button>
            </>
          ) : (
            // MCIF token actions
            <>
              <button
                type="button"
                onClick={onDepositTokens}
                disabled={isLoading || !hasWalletTokens}
                className={`py-2 px-4 rounded-lg font-medium text-white 
                  ${isLoading || !hasWalletTokens
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-blue-500 hover:bg-blue-600 focus:ring-blue-500'
                  } focus:outline-none focus:ring-2 focus:ring-opacity-50 transition`}
              >
                {hasInput 
                  ? `Deposit ${inputAmount} MCIF to Fund` 
                  : `Deposit MCIF to Fund (${parseFloat(walletTokenBalance).toFixed(4)} available)`}
              </button>
              <button
                type="button"
                onClick={onWithdrawTokens}
                disabled={isLoading || !hasFundTokens}
                className={`py-2 px-4 rounded-lg font-medium text-white 
                  ${isLoading || !hasFundTokens
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-blue-500 hover:bg-blue-600 focus:ring-blue-500'
                  } focus:outline-none focus:ring-2 focus:ring-opacity-50 transition`}
              >
                {hasInput 
                  ? `Withdraw ${inputAmount} MCIF from Fund` 
                  : `Withdraw MCIF from Fund (${parseFloat(fundTokenBalance).toFixed(4)} available)`}
              </button>
            </>
          )}
        </div>
      ) : (
        // Mint/Redeem Mode
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button
            type="button"
            onClick={onMint}
            disabled={isLoading || !hasFundEth}
            className={`py-2 px-4 rounded-lg font-medium text-white 
              ${isLoading || !hasFundEth
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-green-500 hover:bg-green-600 focus:ring-green-500'
              } focus:outline-none focus:ring-2 focus:ring-opacity-50 transition`}
          >
            {hasInput 
              ? `Mint ${inputAmount} MCIF with ETH` 
              : `Mint MCIF with ETH (${parseFloat(fundEthBalance).toFixed(4)} ETH available)`}
          </button>
          <button
            type="button"
            onClick={onRedeemFund}
            disabled={isLoading || !hasFundTokens}
            className={`py-2 px-4 rounded-lg font-medium text-white 
              ${isLoading || !hasFundTokens
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-red-500 hover:bg-red-600 focus:ring-red-500'
              } focus:outline-none focus:ring-2 focus:ring-opacity-50 transition`}
          >
            {hasInput 
              ? `Redeem ${inputAmount} MCIF for ETH` 
              : `Redeem MCIF for ETH (${parseFloat(fundTokenBalance).toFixed(4)} available)`}
          </button>
        </div>
      )}
    </div>
  );
};

export default ActionButtons;